/**
 * Invoke a function under condition
 * Use case:
 * const functionToInvoke = () => console.log('INVOKED!)
 * const runOnLocalOnly = runIf(isLocalDomain())
 * runOnLocalOnly(functionToInvoke)
 * @param {Boolean} condition
 * @returns {Function} A Function that accepts another funciont as parameter
 */
export const runIf = (condition) => (func) => condition && func();

/**
 * Run functions with setTimeout guaranteeing the array order
 * @param {Array} functions
 */
export const runAsyncFuncs = (functions) =>
  functions.forEach((func) => {
    if (typeof func === 'function') {
      setTimeout(() => func(), 0);
    } else {
      console.warn('Invalid function passed to runAsyncFuncs:', func);
    }
  });
